import { Inject, Injectable } from '@angular/core'
import { Resolve, ActivatedRouteSnapshot } from '@angular/router'
import { Observable, of } from 'rxjs'
import { LOGGER_SERVICE } from '../logger/logger.config'
import { LoggerService } from '../logger/logger.interface'
import { CategoryService } from '../singleton-services/category.service'
import { catchError } from 'rxjs/operators'
import { getRouteQueryParams } from '../singleton-services/category.service.utility'
import { CategoryView } from '../libs/category-list/category-list.interface'

@Injectable()
export class TeamsListResolver implements Resolve<readonly CategoryView[] | undefined> {
  constructor(
    @Inject(LOGGER_SERVICE) private readonly log: LoggerService,
    private readonly categoryService: CategoryService
  ) {}

  public resolve(route: ActivatedRouteSnapshot): Observable<readonly CategoryView[] | undefined> {
    const queryParams = getRouteQueryParams(route.queryParamMap)
    return this.categoryService.searchTeams$(queryParams).pipe(
      catchError((err: unknown) => {
        this.log.error('error fetching teams data', { err })
        return of([])
      })
    )
  }
}
